/* eslint-disable import/no-named-as-default */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { colors } from '@styleseat/brand';
import useMount from '../../../../hooks/useMount';

import StateManager from '../../../../modules/user/stateManager';

import { BasicStarIcon } from '../../../ui/Icons/BasicStarIcon';
import ManagedModal from '../../../ui/ManagedModal';
import ModalTrigger from '../../../ui/ModalTrigger';

import {
  MONTHLY_GOAL_EXPIRY_DAYS,
  MONTHLY_GOAL_REMINDER_DISMISSED_KEY,
  MonthlyGoalSurvey,
  getGoalText,
} from '../../MonthlyGoal';

import NotificationBanner from '../NotificationBanner';

export const ManageGoalNotification = ({
  goal,
  linkTo,
  notification,
  showReminder,
}) => {
  const [highlightedText, setHighlightedText] = useState();
  const [regularText, setRegularText] = useState();
  const [buttonProps, setButtonProps] = useState();

  useMount(() => {
    const { providerId } = notification;

    let goalText;
    let days;
    let plural;
    let daysLeft;

    if (showReminder) {
      goalText = getGoalText(goal);
      days = moment.duration(moment.utc().diff(moment.utc(goal.time))).asDays();
      plural = daysLeft === 1 ? '' : 's';
      daysLeft = Math.ceil(MONTHLY_GOAL_EXPIRY_DAYS - days);
    }

    setHighlightedText(
      showReminder
        ? `${daysLeft} day${plural} left to meet your goal`
        : 'Set a monthly goal',
    );
    setRegularText(
      showReminder
        ? `of "${goalText}". Here are some tips to help you out.`
        : 'to hit, and expand your business',
    );
    setButtonProps({
      appearance: 'text-light',
      size: 'small',
      text: showReminder ? 'See Tips to Reach My Goal' : 'Set a Goal',
      onClick: () => {
        if (showReminder) {
          StateManager.addAction(
            MONTHLY_GOAL_REMINDER_DISMISSED_KEY,
            moment.utc(),
          );

          linkTo('provider.growth_tab.goals', {
            providerId,
            source: 'notification',
          });
        } else {
          const monthlyGoalSurvey = new ManagedModal({
            triggerType: ModalTrigger,
            renderModal: onClose => React.createElement(MonthlyGoalSurvey, {
              onSurveySubmitted: () => {},
              closeModal: onClose,
              providerId,
              linkTo,
              source: 'notification',
            }),
          });

          monthlyGoalSurvey.open();
        }
      },
      clickTracking: {
        name: showReminder
          ? 'pro_notifications_goal_reminder_click'
          : 'pro_notifications_set_goal_click',
        params: {
          type: goalText,
        },
      },
    });
  });

  return (
    <NotificationBanner
      notification={notification}
      icon={BasicStarIcon}
      iconColor={colors.sunshine}
      highlightedText={highlightedText}
      text={regularText}
      buttonProps={buttonProps}
    />
  );
};

ManageGoalNotification.propTypes = {
  showReminder: PropTypes.bool,
  goal: PropTypes.object,
  linkTo: PropTypes.func,
  notification: PropTypes.object.isRequired,
};

ManageGoalNotification.defaultProps = {
  linkTo: () => {},
  goal: null,
  showReminder: false,
};

export default ManageGoalNotification;
